// Generated by CoffeeScript 1.9.1

/*
ajaxQueue
This function generate queue of ajax calls and start calling
each ajax when the last ajax was completed
 */

(function() {
  (function() {
    var ajaxQueue;
    ajaxQueue = $({});
    return $.ajaxQueue = function(ajaxOptions) {
      var ajaxComplete;
      ajaxComplete = ajaxOptions.complete;
      return ajaxQueue.queue(function(next) {
        ajaxOptions.complete = function() {
          if (ajaxComplete) {
            ajaxComplete.apply(this, arguments);
          }
          return next();
        };
        return $.ajax(ajaxOptions);
      });
    };
  })();

}).call(this);
